// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bruxish: PokeData = {
  "id": 779,
  "name": "bruxish",
  "height": 9,
  "weight": 190,
  "base_experience": 166,
  "types": [
    PokeType.WATER,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "bite",
    "disable",
    "water-gun",
    "confusion",
    "screech",
    "psywave",
    "crunch",
    "astonish",
    "aqua-tail",
    "aqua-jet",
    "psyshock",
    "synchronoise",
    "psychic-fangs",
    "wave-crash"
  ],
  "moves": [
    "bite",
    "psywave",
    "crunch",
    "aqua-tail",
    "aqua-jet",
    "psychic-fangs",
    "liquidation",
    "bubble-beam",
    "calm-mind",
    "psy-pulse",
    "life-dew",
    "synchronize",
    "rain-dance"
  ],
  "evolution_chain": {
    "id": 405,
    "item": null,
    "species": [
      {
        "name": "bruxish",
        "order": 779,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 138,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 80,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
